// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ChoiceContext, GetChoiceContextRequest } from '@digitalasset/cn-allocation-api-ts-client';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { Allocation } from '@daml.js/splice-api-token-allocation/lib/Splice/Api/Token/AllocationV1';
import { ContractId } from '@daml/types';
import { useCNAllocationApi } from '../../../contexts/CNAllocationApiContext';

export const useCNAllocationTransferContext: () => UseMutationResult<
  ChoiceContext,
  string,
  {
    allocationCid: ContractId<Allocation>;
  }
> = () => {
  const { allocationClient } = useCNAllocationApi();
  const getChoiceContextRequest: GetChoiceContextRequest = { meta: {} };

  return useMutation({
    mutationKey: ['cnAllocationTransferContext', allocationClient],
    mutationFn: async ({ allocationCid }) => {
      return allocationClient.getAllocationTransferContext(allocationCid, getChoiceContextRequest);
    },
  });
};
